<template>
  <process-menu :items="serviceProviders" />
</template>

<script>
import ProcessMenu from '@/components/ProcessMenu'

export default {
  components: { ProcessMenu },
  data: () => ({
    serviceProviders: [
      {
        src: require('@/assets/img/team-mgmt.png'),
        heading: 'Claims Team Management',
        text: 'Manage system users',
        link: { name: 'TeamTable' },
        roles: ['admin', 'internalAssessor'],
      },
      {
        src: require('@/assets/img/team-mgmt.png'),
        heading: 'Approver Management',
        text: 'Manage approval bands and users',
        link: { name: 'ApproverManagement' },
        roles: ['admin'],
      },
      {
        src: require('@/assets/img/team-mgmt.png'),
        heading: 'TAT Management',
        text: 'Manage Turn Around Time',
        link: { name: 'TATManagement' },
        roles: ['admin'],
      },
      {
        src: require('@/assets/img/vehicle-part-management.png'),
        heading: 'Parts Management',
        text: 'For parts, addition, editing and management',
        link: { name: 'PartsManagement' },
        roles: ['admin'],
      },
    ],
  }),
}
</script>
